import { SignupPasswordStep } from "@/components/auth/SignupPasswordStep";
import { usePageTitle } from "../hooks/usePageTitle";

export function SignupPasswordPage() {
  usePageTitle("Choose a password | TidyRota");

  return <SignupPasswordStep />;
}
